import React, { useEffect, useState } from "react";
import { Stack, Image, Badge } from "react-bootstrap";

interface HeaderState {
  user: any;
  profileImage: string;
}

const MemberHeader = ({ user, profileImage }: HeaderState) => {
  const heading = `${user?.firstname} ${user?.preferredname ? "'" + user?.preferredname + "'" : ""} ${user?.lastname}`;
  const [banDateExpired, setBanDateExpired] = useState<boolean>(false);

  useEffect(() => {
    if (user?.banned_expiration_at) {
      const expireDate = new Date(user?.banned_expiration_at);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      setBanDateExpired(expireDate <= today);
    }
  }, [user]);

  return (
    <Stack className="flex-column flex-xl-row align-items-start align-items-xl-start" gap={3}>
      {profileImage ? (
        <Image src={profileImage} rounded className="image-avatar" />
      ) : (
        <Image src="/blank-profile-picture.jpg" className="image-avatar" />
      )}
      <Stack gap={1} className="my-0">
        <h4 className="app-header-text mb-0">{heading}</h4>
        <Stack direction="horizontal" gap={2}>
          {user?.relationship && <h6 className={"text-capitalize app-header-text mb-0"}>{user?.relationship}</h6>}
          {user?.is_case_subject === 1 && (
            <Badge bg="none" className="app-secondary-color">
              Person Served
            </Badge>
          )}
          {user?.is_primary === 1 && (
            <Badge bg="none" className="app-tertiary-color">
              Main Contact
            </Badge>
          )}
          {user?.is_banned === 1 && (
            <div>
              <Badge bg="none" className="app-danger-color">
                Banned
              </Badge>
              <small className="app-danger-text ms-2">
                {banDateExpired
                  ? `Ban Expired`
                  : `Banned ${user?.banned_expiration_at ? "Until " + user?.banned_expiration_at : "Indefinitely"}`}
              </small>
            </div>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MemberHeader;
